const handoverProtocol = {
	name: 'Übergabeprotokoll | Übergabeprotokolle',
}

export default handoverProtocol
